import React from "react";

const Termsandconditions = () => {
  return (
    <section className="w-full py-16 px-8 md:px-24 bg-[#02042b] text-white mt-12">
      <div className="max-w-3xl mx-auto space-y-10">
        <h1 className="text-5xl md:text-6xl font-extrabold text-center text-white">
          Terms and Conditions
        </h1>
        <p className="text-center text-lg text-white">
          Effective Date: July 11, 2025
        </p>

        <p className="text-center text-xl text-white">
          Please read these terms carefully before using our website and services.
        </p>

        <hr className="border-gray-600 my-8" />

        <div className="space-y-8">
          <div>
            <h2 className="text-3xl font-semibold text-white border-l-4 border-indigo-400 pl-4 mb-4">
              1. Information We Collect
            </h2>
            <p className="mb-3 text-lg text-white">We may collect the following data:</p>
            <ul className="list-disc list-inside space-y-2 text-lg text-white">
              <li>Full name, contact number, and email address</li>
              <li>Educational details (university, subject, deadlines)</li>
              <li>Assignment brief, guidelines, or materials you provide</li>
              <li>Payment details (processed securely through third-party gateways)</li>
              <li>IP address, browser type, and usage data (for analytics and security)</li>
            </ul>
          </div>

          <div>
            <h2 className="text-3xl font-semibold text-white border-l-4 border-indigo-400 pl-4 mb-4">
              2. How We Use Your Information
            </h2>
            <p className="mb-3 text-lg text-white">Your information is used for:</p>
            <ul className="list-disc list-inside space-y-2 text-lg text-white">
              <li>Providing custom academic writing help (assignment, essay, dissertation, thesis, report)</li>
              <li>Delivering project updates and support</li>
              <li>Processing payments and invoices</li>
              <li>Marketing (email/SMS with offers only with your consent)</li>
              <li>Ensuring service quality and legal compliance</li>
            </ul>
          </div>

          <div>
            <h2 className="text-3xl font-semibold text-white border-l-4 border-indigo-400 pl-4 mb-4">
              3. Data Protection and Storage
            </h2>
            <p className="text-lg text-white">
              We employ industry-standard encryption, firewalls, and secured servers to store your data. Access is restricted to authorized personnel only. We never share or sell your data to third parties.
            </p>
          </div>

          <div>
            <h2 className="text-3xl font-semibold text-white border-l-4 border-indigo-400 pl-4 mb-4">
              4. Cookies and Tracking
            </h2>
            <p className="mb-3 text-lg text-white">We use cookies to:</p>
            <ul className="list-disc list-inside space-y-2 text-lg text-white">
              <li>Improve site performance</li>
              <li>Analyze visitor behavior (using tools like Google Analytics)</li>
              <li>Personalize user experience</li>
            </ul>
            <p className="mt-3 text-lg text-white">
              You can modify or reject cookies through your browser settings.
            </p>
          </div>

          <div>
            <h2 className="text-3xl font-semibold text-white border-l-4 border-indigo-400 pl-4 mb-4">
              5. Third-Party Tools
            </h2>
            <p className="mb-3 text-lg text-white">We may use trusted tools like:</p>
            <ul className="list-disc list-inside space-y-2 text-lg text-white">
              <li>Google Analytics</li>
              <li>CRM</li>
              <li>Calling Tools</li>
              <li>Secure Payment Gateways (Razorpay, PayPal, etc.)</li>
            </ul>
            <p className="mt-3 text-lg text-white">
              These services may collect limited data as per their privacy policies.
            </p>
          </div>

          <div>
            <h2 className="text-3xl font-semibold text-white border-l-4 border-indigo-400 pl-4 mb-4">
              6. Your Rights
            </h2>
            <p className="mb-3 text-lg text-white">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2 text-lg text-white">
              <li>Access your data</li>
              <li>Request correction or deletion</li>
              <li>Opt-out of marketing communications</li>
            </ul>
            <p className="mt-4 text-lg text-white">
              For any requests, contact: <a href="mailto:info@infinitesolutionedu.com" className="underline text-indigo-300 hover:text-indigo-200">info@infinitesolutionedu.com</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Termsandconditions;
